import { render, staticRenderFns } from "./NarrativeList.vue?vue&type=template&id=b6ea336c&"
import script from "./NarrativeList.vue?vue&type=script&lang=js&"
export * from "./NarrativeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports